
export default function IntroSection() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
              Your Small Business Deserves a <span className="text-teal-600">Professional Website</span>
            </h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              In today's digital landscape, having a professional website isn't just an option—it's essential 
              for small business success. Whether you're a local restaurant, retail shop, service provider, 
              or consultant in El Paso, your website serves as your digital storefront, working 24/7 to 
              attract customers and grow your business.
            </p>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              At David's Website Design, we specialize in creating stunning, functional websites specifically 
              tailored for small businesses in El Paso, Texas. Our expert team understands the unique 
              challenges and opportunities that local businesses face, and we craft websites that not only 
              look amazing but also drive real results.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Local El Paso Expertise</h3>
                  <p className="text-gray-600">We understand the El Paso market and create websites that resonate with your local customers.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Proven Track Record</h3>
                  <p className="text-gray-600">Over 200 successful small business websites launched in the El Paso area with measurable results.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Full-Service Support</h3>
                  <p className="text-gray-600">From design to launch and beyond, we provide comprehensive support for your online success.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/073134f5977a905a68add32e92f2a95b.jpg"
              alt="Small business owner planning their professional website strategy"
              className="w-full h-96 object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-xl shadow-xl">
              <div className="text-3xl font-bold text-teal-600 mb-1">98%</div>
              <div className="text-sm text-gray-600">Customer Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
